<template>
  <div class="form-checkbox">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
      style="margin-bottom: 10px"
    />
    <gkFormCustomGroup
      :field="data.id.toString()"
      :rule="isValidity ? rules : []"
      :validity="isValidity"
      v-model="value"
    >
      <template v-for="(option, i) in options">
        <div class="item" :key="i">
          <gkFormCheck
            class="my-form-check"
            type="checkbox"
            color="infoqCheckbox"
            :value="`${option.key}${dataConcatStr}${option.title}${dataConcatStr}${data.type}`"
            :label="option.title"
            @change="handleChange(option, $event)"
            v-model="value"
          />
          <div class="other" v-if="showInput && option.type === COMPONENT_CONST.InputMultiSelection">
            <gkFormText
              :field="'checkUseless'"
              :placeholder="option.tips"
              :rule="isValidity && option.is_must_answer ? [{required: '请填写'}] : []"
              size="small"
              color="gray"
              :validity="isValidity"
              v-model="textQuestion.textValue"
              @input="input(option, $event)"
            />
            <span class="tip" v-if="option.is_must_answer">(必填)</span>
          </div>
        </div>
      </template>
    </gkFormCustomGroup>
  </div>

</template>
<script>
import VueTypes from 'vue-types'

import gkFormCheck from 'gkui/form/FormCheck'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import gkFormText from 'gkui/form/FormText'
import FormTitle from '@/components/FormTitle'
import * as COMPONENT_CONST from '../const'

import config from '@/config'

export default {
  name: 'form-checkbox',
  props: {
    data: VueTypes.object,
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
    gkFormCustomGroup,
    gkFormCheck,
    FormTitle,
    gkFormText
  },
  data () {
    return {
      checkVal: [],
      value: [],
      selectType: [],
      textQuestion: {
        key: '',
        textValue: ''
      },
      COMPONENT_CONST,
      dataConcatStr: config.dataConcatStr
    }
  },
  computed: {
    options () {
      return this.data.details.options
    },
    rules () {
      let rule = []
      if (this.data.is_must_answer) {
        rule.push({
          required: '请选择至少一项'
        })
      }
      return rule
    },
    showInput () {
      return this.selectType.includes(this.COMPONENT_CONST.InputMultiSelection)
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    }
  },
  created () {
  },
  methods: {
    handleChange (option, $event) {
      this.value = $event

      if (this.selectType.includes(option.type)) {
        this.selectType = this.selectType.filter(val => val !== option.type)
      } else {
        this.selectType.push(option.type)
      }

      let newValue = this.value.map(item => {
        if (this.textQuestion.key && item.indexOf(this.textQuestion.key) > -1) {
          let arr = item.split(config.dataConcatStr)
          arr[1] = this.textQuestion.textValue ? this.textQuestion.textValue : '其他'
          item = arr.join(config.dataConcatStr)
        }
        return item
      })
      this.value = newValue
    },
    input (option, $event) {
      if (this.selectType.includes(this.COMPONENT_CONST.InputMultiSelection)) {
        if ($event) {
          let filterSelectValue = this.value.filter(data => data.indexOf(option.key) < 0)
          this.textQuestion.key = option.key
          this.value = [...filterSelectValue, `${option.key}${this.dataConcatStr}${$event}${this.dataConcatStr}${this.data.type}`]
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/_common";

.form-checkbox {

  & .item {
    display: flex;
    align-items: center;
    min-height: 22px;
    padding: 8px 0;

    &:last-child {
      padding-bottom: 0;
    }

    & .my-form-check {
      align-items: flex-start;
      flex: none;
      max-width: 100%;
    }

    & ::v-deep {
      & .gkui-form-element[data-color="gray"] {
        min-height: 22px;

        & .gkui-form-error {
          bottom: -88%;
        }
      }

      & [gkcheck-color="infoqCheckbox"] {
        flex: none;
        width: 18px; height: 18px;
        margin-top: 2px;
      }

      & [gkcheck-color="infoqCheckbox"] + span {
        font-size: 16px; line-height: 22px;
        color: $bodyBlack;
        word-break: break-all;
      }

      & [checked="checked"] + span {
        color: $blue;
      }

      & [gkcheck-color="infoqCheckbox"][checked="checked"] {
        border: 1px solid $blue;
        background: $blue;

        & span {
          width: 100%; height: 100%;
        }
      }

      & [gkcheck-color="infoqCheckbox"] [gk-checked]:after {
        left: 3px; top: 3px;
        width: 11px; height: 6px;
        border-left: 2px solid #ffffff; border-bottom: 2px solid #ffffff;
      }
    }

    & [data-size="small"] {
      flex: 1;
      height: 22px;
      border: none; border-bottom: 1px solid #4A4A4A; border-radius: 0;
    }

    & .other {
      display: flex;
      align-items: center;
      padding-left: 7px;

      & ::v-deep .gkui-form-element {
        width: 210px;

        & .gkui-form-text {
          padding: 0 6px;
          line-height: 22px;
          color: #4a4a4a;
        }
      }

      & .tip {
        padding-left: 11px;
        @include font(16, 400);
        line-height: 22px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .form-checkbox .item .other ::v-deep .gkui-form-element {
    width: 100px;
  }
}
</style>
